var map = {
	"./modules/lazy-loaded/alerts/alerts.module": [
		"./src/app/modules/lazy-loaded/alerts/alerts.module.ts",
		"common",
		"modules-lazy-loaded-alerts-alerts-module"
	],
	"./modules/lazy-loaded/applications/applications.module": [
		"./src/app/modules/lazy-loaded/applications/applications.module.ts",
		"common",
		"modules-lazy-loaded-applications-applications-module"
	],
	"./modules/lazy-loaded/dashboard/dashboard.module": [
		"./src/app/modules/lazy-loaded/dashboard/dashboard.module.ts",
		"default~modules-lazy-loaded-dashboard-dashboard-module~modules-lazy-loaded-devices-devices-module",
		"common",
		"modules-lazy-loaded-dashboard-dashboard-module"
	],
	"./modules/lazy-loaded/data-logger/data-logger.module": [
		"./src/app/modules/lazy-loaded/data-logger/data-logger.module.ts",
		"modules-lazy-loaded-data-logger-data-logger-module"
	],
	"./modules/lazy-loaded/devices/devices.module": [
		"./src/app/modules/lazy-loaded/devices/devices.module.ts",
		"default~modules-lazy-loaded-devices-devices-module~modules-lazy-loaded-groups-groups-module~modules-~d3c23d61",
		"default~modules-lazy-loaded-dashboard-dashboard-module~modules-lazy-loaded-devices-devices-module",
		"common",
		"modules-lazy-loaded-devices-devices-module"
	],
	"./modules/lazy-loaded/groups/groups.module": [
		"./src/app/modules/lazy-loaded/groups/groups.module.ts",
		"default~modules-lazy-loaded-devices-devices-module~modules-lazy-loaded-groups-groups-module~modules-~d3c23d61",
		"common",
		"modules-lazy-loaded-groups-groups-module"
	],
	"./modules/lazy-loaded/maintenance/maintenance.module": [
		"./src/app/modules/lazy-loaded/maintenance/maintenance.module.ts",
		"modules-lazy-loaded-maintenance-maintenance-module"
	],
	"./modules/lazy-loaded/map/map.module": [
		"./src/app/modules/lazy-loaded/map/map.module.ts",
		"default~modules-lazy-loaded-devices-devices-module~modules-lazy-loaded-groups-groups-module~modules-~d3c23d61",
		"common",
		"modules-lazy-loaded-map-map-module"
	],
	"./modules/lazy-loaded/profile/profile.module": [
		"./src/app/modules/lazy-loaded/profile/profile.module.ts",
		"modules-lazy-loaded-profile-profile-module"
	],
	"./modules/lazy-loaded/settings/settings.module": [
		"./src/app/modules/lazy-loaded/settings/settings.module.ts",
		"common",
		"modules-lazy-loaded-settings-settings-module"
	],
	"./modules/lazy-loaded/user-management/user-management.module": [
		"./src/app/modules/lazy-loaded/user-management/user-management.module.ts",
		"common",
		"modules-lazy-loaded-user-management-user-management-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;